import { yupResolver } from "@hookform/resolvers/yup";
import { AlertColor } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import ButtonGeneric from "../../components/ButtonGeneric";
import InputGeneric from "../../components/InputGeneric";
import PageWrapper from "../../components/PageWrapper/index";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";
import { FormGraceDayEditPage } from "./styles";

type graceDayFormTypeValues = {
    days: number;
};

const graceDayFormSchema = yup.object().shape({
    days: yup.number().required(),
});

function GraceDayEditPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("dias.carencia.editar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm<graceDayFormTypeValues>({
        resolver: yupResolver(graceDayFormSchema),
    });

    useEffect(() => {
        api.get(`/graceDay/${myParam}`).then((response) => {
            setValue("days", response.data.response.days);
        });
    }, [myParam, setValue]);

    const editHolderType: SubmitHandler<graceDayFormTypeValues> = async (
        formValues
    ) => {
        setIsLoadingButton(true);
        api.put(`/graceDay/${myParam}`, {
            days: formValues.days,
        })
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    navigate("/settings/graceDays");
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.response.name);
                setIsLoadingButton(false);
            });
    };

    return (
        <PageWrapper>
            <FormGraceDayEditPage>
                <div className="topFormPage">
                    <h2>Editar Período de Carência</h2>
                </div>
                <form onSubmit={handleSubmit(editHolderType)}>
                    <div className="inputsContainer">
                        <Controller
                            control={control}
                            name="days"
                            render={({
                                field: { onChange, onBlur, value = "", ref },
                            }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    size="small"
                                    type="number"
                                    className="inputs"
                                    label="Dias"
                                    error={!!errors.days}
                                    ref={ref}
                                    autoFocus
                                />
                            )}
                        />
                    </div>
                    <div className="buttonsContainer">
                        <ButtonGeneric
                            onclick={() => navigate("/settings/graceDays")}
                            buttonColor="var(--cancel)"
                            text="VOLTAR"
                        />
                        <PreloadButton
                            colorText="white"
                            background="var(--confirm)"
                            loading={isLoadingButton}
                            text="CONFIRMAR"
                            type="submit"
                        />
                    </div>
                </form>
                <Toast
                    open={openToast}
                    onClose={() => handleCloseToast()}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </FormGraceDayEditPage>
        </PageWrapper>
    );
}
export default GraceDayEditPage;
